import React, { useState } from 'react';
import { Accordion, useAccordionButton } from 'react-bootstrap';
import HTMLReactParser from 'html-react-parser';
import './CustomAccordion.css';

function CustomToggle({ children, eventKey, callback }) {
  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

  return (
    <button
      type="button"
      style={{ backgroundColor: 'black' }}
      onClick={decoratedOnClick}
      className="accordion-button collapsed w-100 text-white border-0 p-3">
      {children}
    </button>
  );
}
const CustomAccordion = ({ items, renderList = false, parameters = {} }) => {
  const [activeKey, setActiveKey] = useState(null);

  return (
    <div className="bg-black w-100">
      <Accordion
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k)}
        className="custom-accordion">
        {items?.length > 0 &&
          items.map((content, index) => (
            <Accordion.Item
              key={index}
              eventKey={index.toString()}
              className="border-0 mb-3 bg-black">
              <CustomToggle
                eventKey={index.toString()}
                callback={() =>
                  setActiveKey(activeKey === index.toString() ? null : index.toString())
                }>
                <div className="title-item-accordion d-flex justify-content-between align-items-center w-100">
                  <span>
                    {renderList ? `${parameters?.INF_MSG_101?.value} ${index + 1}: ` : ''}
                    {content.value || content.title}
                  </span>
                  <div className="container-chevron px-2">
                    <span
                      className={`chevron d-flex flex-end ${
                        activeKey === index.toString() ? 'chevron-up' : 'chevron-down'
                      }`}></span>
                  </div>
                </div>
              </CustomToggle>
              <Accordion.Body className="custom-ta-content text-white border-top-0 rounded-bottom p-3">
                {renderList ? (
                  <ul className="m-0 px-3 text-white">
                    {content.description?.map((item, index) => (
                      <div key={`${index}12`} className="px-0 mx-0">
                        {item}
                      </div>
                    ))}
                  </ul>
                ) : (
                  content.description_value ||
                  HTMLReactParser(content.description || '', {
                    trim: true
                  })
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
      </Accordion>
    </div>
  );
};

export default CustomAccordion;
